import {
  Component,
  Input,
  NgZone,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ExportService,
  LoggingService,
  ToastrService,
  UserSessionsChartData,
  UserSessionsChartDataPoint,
} from "app/shared";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";
import { UsersSessionsActiveConfig } from "app/shared/model/charts/user-analytic-configurations.model";

@Component({
  selector: "users-sessions-active-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class UsersSessionsActiveChartComponent
  extends BaseChartLogic<UsersSessionsActiveConfig, UserSessionsChartData>
  implements OnInit, OnDestroy
{
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      UsersSessionsActiveConfig,
      _ngZone
    );

    this.handleDataSubscription(
      this.analyticsService.usersCurrentlyOnlineDataChange
    );

    // // this data requires custom handling
    // this.subscriptions.push(
    //   this.analyticsService.usersCurrentlyOnlineDataChange.subscribe((data: TData) => {
    //     _ngZone.run(() => {
    //       if (this.testForNoData(data)) {
    //         this.handleNoData();
    //         return;
    //       }
    //       //I am here
    //       this.processDataForChart(data);

    //     });
    //   })
    // );
  }

  // labels: [
  //   "Application Administrators",
  //   "Customers",
  //   "Employees",
  //   "Komatsu Employees",
  //   "Minesite",
  //   "Parent Company",
  // ],

  // this.analyticsService.usersCurrentlyOnlineDataChange.subscribe((data) => {
  //   this.isLoading = false;
  //   this.currentUsersData.datasets[0].data = [
  //     data.ActiveSessionsForApplicationAdministrator,
  //     data.ActiveSessionsForCustomers,
  //     data.ActiveSessionsForEmployees,
  //     data.ActiveSessionsForKomatsuEmployees,
  //     data.ActiveSessionsForMinesite,
  //     data.ActiveSessionsForParentCompany,
  //   ];
  //   //aggregate data points on the daily level

  // /**
  //  * Override method, custom handling for data
  //  * @param data
  //  * @returns
  //  */
  // protected processDataForChart(data?: UserSessionsChartData) {
  //   this.analyticsData = data;
  //   this.loggingService.log("BaseChartLogic override - UserSessionsChartData - processDataForChart");
  //   //clear values
  //   this.chartData.labels = [];
  //   this.listDisplayData = [];
  //   this.chartData.datasets[0].data = [];
  //   this.chartData.datasets[0].label = this.chartDetails.title || "";
  //   this.chartOptions.plugins.title.text = this.chartDetails.title || "";

  //   if (
  //     !this.analyticsData ||
  //     !this.analyticsData.DataPoints ||
  //     this.analyticsData.DataPoints.length === 0
  //   ) {
  //     return;
  //   }

  //   //add common data back
  //   this.chartData.datasets[0].label = this.chartDetails?.title || "";
  //   this.buildListDisplayData(
  //     this.analyticsData,
  //     this.config?.generalSettings?.showAllData || false
  //   );
  //   this.chartData.datasets[0].data = this.analyticsData.DataPoints.map((dp) =>
  //     this.getDataPointDisplayValue(dp)
  //   );
  //   this.handleLabels(this.analyticsData);
  //   this.handleChartDisplaySettings();
  //   this.hasData = true;
  //   this.loggingService.log(
  //     "BaseChartLogic - processDataForChart - set isLoading = false"
  //   );
  //   this.isLoading = false;
  // }

  dataPointKey: string = "Active";
  protected getDataPointDisplayValue(
    dataPoint: UserSessionsChartDataPoint
  ): any {
    return dataPoint.ActiveSessions;
  }
  // add expiration date to filter -- see other chart component files
  buildFilterSettings(): void {
    this.loggingService.log(
      "UsersSessionsActiveChartComponent - buildFilterSettings"
    );
    this.addExpirationPeriodtoFilterSettings();
  }

  refreshData(): void {
    this.analyticsService.getUsersCurrentlyOnlineData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}
